module.exports = __webpack_public_path__ + "img/1-3.15765e0b.svg";